// TEMPORARY: Ta bort denna komponent när Transportstyrelsens beslut godkänts (importeras i App.js > Home)
import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Info, X, ArrowRight } from "lucide-react";
import { scrollToId } from "../hooks/useLenis";

export const NoticePopup = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 800);
    return () => clearTimeout(t);
  }, []);

  const close = () => setVisible(false);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="notice-popup-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 z-[80] flex items-center justify-center px-4 bg-[#090d16]/70 backdrop-blur-sm"
          onClick={close}
        >
          <motion.div
            data-testid="notice-popup"
            initial={{ opacity: 0, scale: 0.92, y: 30 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            transition={{ type: "spring", stiffness: 260, damping: 22, delay: 0.1 }}
            onClick={(e) => e.stopPropagation()}
            className="relative w-[min(94vw,480px)] rounded-3xl bg-white p-7 sm:p-9 shadow-2xl"
          >
            <button
              data-testid="notice-popup-close"
              onClick={close}
              aria-label="Stäng"
              className="absolute top-4 right-4 w-9 h-9 rounded-full bg-slate-100 hover:bg-slate-200 flex items-center justify-center text-slate-500 transition-colors duration-300"
            >
              <X className="w-4 h-4" />
            </button>

            <span className="w-12 h-12 rounded-2xl bg-[#16a34a]/10 flex items-center justify-center mb-5">
              <Info className="w-6 h-6 text-[#16a34a]" />
            </span>

            <h3 className="font-display font-extrabold text-2xl sm:text-[1.7rem] text-[#0b0f19] tracking-tight leading-tight">
              Vi inväntar beslut om flytttillstånd
            </h3>
            <p className="mt-4 text-sm sm:text-base text-slate-600 leading-relaxed">
              Vi utför för närvarande inga flyttar då vi inväntar beslut från Transportstyrelsen.
              Preliminärt första flyttdatum är <strong>början av sommaren 2027</strong> – förhoppningsvis tidigare.
            </p>
            <p className="mt-3 text-sm sm:text-base text-slate-600 leading-relaxed">
              Du kan redan nu skicka din offertförfrågan – vi återkommer så snart beskedet är klart.
            </p>

            <div className="mt-7 flex flex-wrap gap-3">
              <button
                data-testid="notice-popup-cta"
                onClick={() => {
                  close();
                  scrollToId("#offert");
                }}
                className="group bg-[#16a34a] hover:bg-[#15803d] text-white font-bold text-sm px-6 py-3.5 rounded-full flex items-center gap-2 transition-colors duration-300"
              >
                Skicka offertförfrågan ändå
                <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
              </button>
              <button
                data-testid="notice-popup-ok"
                onClick={close}
                className="text-slate-600 font-semibold text-sm px-6 py-3.5 rounded-full border border-slate-200 hover:border-slate-400 transition-colors duration-300"
              >
                Jag förstår
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
